import { Component, OnInit } from '@angular/core';
import { EditTenderModel } from "../../../models/inModels/Tender";
import { TenderService } from "../../../services/business/tender.service";
import { Message } from "primeng/components/common/message";
import { SelectItem } from "primeng/components/common/selectitem";
import { BusinessService } from "../../../services/business/business-category.service";
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { StorageService } from "../../../services/system/storage.service";

@Component({
	selector: 'app-tenders-edit',
	templateUrl: './tenders-edit.component.html',
	styleUrls: ['./tenders-edit.component.css']
})
export class TendersEditComponent implements OnInit {
	id;
	model: EditTenderModel;
	loading = false;
	error: Message[];
	messages: Message[];
	categories: SelectItem[];
	provinces: SelectItem[];
	selectedCategory;
	selectedProvince;
	uploading = false;
	tenders;
	selectedTenderType;
	tenderTypeId: SelectItem[];
	
	constructor(
		private storageService: StorageService,
		private route: ActivatedRoute,
		private router: Router,
		private service: TenderService,
		private businessService: BusinessService) {
		this.id = this.route.snapshot.paramMap.get('Id');
	}

	ngOnInit() {
		this.getTender();
	}

	getTender() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.model = new EditTenderModel(result);
				this.selectedCategory = { value: result.BusinessCategoryId, label: result.BusinessCategory };
				this.selectedProvince = { value: result.ProvinceId, label: result.Province };
				this.selectedTenderType = { value: result.TenderTypeId, label: result.TenderType };
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	initCategoryDropDown(event) {
		this.businessService.getDropdown(event).then(
			x => {
				this.categories = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setCategory(): void {
		this.model.businessCategoryId = this.selectedCategory.value;
	}
	initProvinceDropDown(event) {
		this.service.getProvinceDropdown(event).then(
			x => {
				this.provinces = x ;
			},
			error => {
				this.error = [];
				this.error.push({severity: 'error', summary: 'Error', detail: error})
			}
		)
	}

	setProvince(): void{
		this.model.provinceId = this.selectedProvince.value;
	}

	goBack(): void {
		this.router.navigate(['/tenders']);
	}

	handleFile(event, property): void {
		var result = this.storageService.handleSuccess(event);
		this.model[property] = result.PublicId;
		this.uploading = false;
	}

	handleError(event): void {
		this.uploading = false;
		this.messages = [];
		this.storageService.handleError(event, this.messages);
	}

	viewDocument(property): void {
		window.open(`${this.storageService.viewUrl}/${this.model[property]}`, '_blank');
	}

	removeDocument(property): void {
		this.model[property] = null;
		this.uploading = false;
	}

	save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.model = new EditTenderModel(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Tender saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	initTenderTypeDropDown(event): void {
		this.service.getTenderTypeDropdownList(event).then(
			x => {
				this.tenders = x;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setTenderType(): void {
		this.model.tenderTypeId = this.selectedTenderType.value;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/tenders/tenders-edit/tenders-edit.component.ts